import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getMotorBillingInfoSlice = createSlice({
  name: "getMotorBillingInfo",
  initialState,
  reducers: {
    getMotorBillingInfoStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getMotorBillingInfoSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getMotorBillingInfoFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getMotorBillingInfoStart,
  getMotorBillingInfoSuccess,
  getMotorBillingInfoFailure,
  clearError,
  clearMessage,
} = getMotorBillingInfoSlice.actions;

export default getMotorBillingInfoSlice.reducer;
